<template>
  <div class="book-page">
    <div class="page-title">{{ courseName || "教材列表" }}</div>
    <el-table :data="textbooks" v-loading="loading" stripe>
      <el-table-column label="教材" min-width="320">
        <template slot-scope="scope">
          <div class="textbook-cell">
            <el-image
              v-if="scope.row.coverUrl"
              :src="scope.row.coverUrl"
              :preview-src-list="[scope.row.coverUrl]"
              class="textbook-cover"
              fit="cover"
            >
              <div slot="error" class="cover-empty">
                <i class="el-icon-reading"></i>
              </div>
            </el-image>
            <div v-else class="cover-empty">
              <i class="el-icon-reading"></i>
            </div>
            <span class="textbook-name">{{ scope.row.textbookName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="edition" label="版次" width="120" />
      <el-table-column prop="knowledgeCount" label="知识点数" width="120" />
      <el-table-column label="状态" width="120">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.locked" type="warning">🔒 未开通</el-tag>
          <el-tag v-else type="success">已开通</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.locked"
            type="text"
            @click="unlock(scope.row)"
            >开通教材</el-button
          >
          <el-button v-else type="text" @click="goKnowledge(scope.row)"
            >查看知识点</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getBookTextbookByCourse, openBookTextbook } from "@/api/book";
import { getBookUserStatus } from "@/api/bookUser";

export default {
  name: "BookTextbookIndex",
  data() {
    return {
      loading: false,
      textbooks: [],
      courseId: null,
      courseName: "",
      requireActivationCode: false,
      bookUserStatus: {}
    };
  },
  async mounted() {
    this.courseId = this.$route.query.courseId;
    this.courseName = this.$route.query.courseName || "";
    await this.loadBookUserStatus();
    this.loadData();
  },
  methods: {
    async loadBookUserStatus() {
      try {
        const res = await getBookUserStatus();
        if (res.code === 200 || res.code === 0) {
          this.bookUserStatus = res.data || {};
          this.requireActivationCode =
            res.data && res.data.registerChannel === "book_personal";
          return this.bookUserStatus;
        }
      } catch (e) {
        this.bookUserStatus = {};
        this.requireActivationCode = false;
      }
      return this.bookUserStatus;
    },
    async loadData() {
      if (!this.courseId) {
        this.$message.error("课程ID缺失");
        return;
      }
      this.loading = true;
      try {
        const res = await getBookTextbookByCourse(this.courseId);
        if (res.code === 200 || res.code === 0) {
          this.textbooks = res.data || [];
        } else {
          this.$message.error(res.message || "加载教材失败");
        }
      } finally {
        this.loading = false;
      }
    },
    async unlock(row) {
      let activationCode = null;
      if (this.requireActivationCode) {
        try {
          const promptRes = await this.$prompt("请输入教材激活码", "开通教材", {
            confirmButtonText: "确认开通",
            cancelButtonText: "取消",
            inputPlaceholder: "请输入激活码",
            inputValidator: value => {
              if (!value || !value.trim()) {
                return "激活码不能为空";
              }
              return true;
            }
          });
          activationCode = (promptRes.value || "").trim();
        } catch (e) {
          return;
        }
      }

      const loading = this.$loading({
        lock: true,
        text: "开通中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)"
      });
      try {
        const res = await openBookTextbook(row.id, activationCode);
        if (res.code === 200 || res.code === 0) {
          const status = await this.loadBookUserStatus();
          if (
            status &&
            status.registerChannel === "book_personal" &&
            status.nextStep === "JOIN_CLASS"
          ) {
            this.$message.success("开通成功，要使用功能，必须先加入班级");
          } else {
            this.$message.success("开通成功");
          }
          await this.loadData();
        } else {
          this.$message.error(res.message || "开通失败");
        }
      } finally {
        loading.close();
      }
    },
    goKnowledge(row) {
      this.$router.push({
        path: "/bookKnowledge",
        query: {
          textbookId: row.id,
          textbookName: row.textbookName
        }
      });
    }
  }
};
</script>

<style scoped>
.book-page {
  background: #fff;
  padding: 16px;
  border-radius: 10px;
}
.page-title {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 16px;
}
.textbook-cell {
  display: flex;
  align-items: center;
  min-width: 0;
}
.textbook-cover,
.cover-empty {
  flex: 0 0 56px;
  width: 56px;
  height: 76px;
  border-radius: 4px;
}
.textbook-cover {
  border: 1px solid #ebeef5;
  background: #f5f7fa;
}
.cover-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  background: #f5f7fa;
  border: 1px dashed #dcdfe6;
  font-size: 22px;
}
.textbook-name {
  min-width: 0;
  margin-left: 12px;
  color: #303133;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
}
</style>
